import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-activity-skeleton-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="skeleton-activity-container">
      <!-- Header section -->
      <div class="skeleton-header">
        <div class="skeleton-title"></div>
      </div>
      
      <!-- Form content -->
      <div class="skeleton-form">
        <!-- Title input -->
        <div class="skeleton-input-large"></div>
        
        <!-- Action buttons -->
        <div class="skeleton-action-buttons">
          <div class="skeleton-button skeleton-button-primary"></div>
          <div class="skeleton-button"></div>
          <div class="skeleton-button"></div>
        </div>
        
        <!-- Date and time section -->
        <div class="skeleton-datetime">
          <div class="skeleton-date-block">
            <div class="skeleton-label"></div>
            <div class="skeleton-input"></div>
          </div>
          <div class="skeleton-time-block">
            <div class="skeleton-label"></div>
            <div class="skeleton-input"></div>
          </div>
          <div class="skeleton-time-block">
            <div class="skeleton-label"></div>
            <div class="skeleton-input"></div>
          </div>
        </div>
        
        <!-- Attendees section -->
        <div class="skeleton-attendees">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        
        <!-- Notes section -->
        <div class="skeleton-notes">
          <div class="skeleton-label"></div>
          <div class="skeleton-toolbar">
            <div class="skeleton-tool"></div>
            <div class="skeleton-tool"></div>
            <div class="skeleton-tool"></div>
            <div class="skeleton-tool"></div>
            <div class="skeleton-tool"></div>
            <div class="skeleton-tool"></div>
          </div>
          <div class="skeleton-textarea"></div>
        </div>
        
        <!-- Lead name section -->
        <div class="skeleton-lead">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        
        <!-- Owner section -->
        <div class="skeleton-owner">
          <div class="skeleton-label"></div>
          <div class="skeleton-dropdown"></div>
        </div>
        
        <!-- Bottom buttons -->
        <div class="skeleton-bottom-actions">
          <div class="skeleton-button"></div>
          <div class="skeleton-checkbox"></div>
          <div class="skeleton-button skeleton-button-primary"></div>
        </div>
      </div>
      
      <!-- Calendar section -->
      <div class="skeleton-calendar">
        <div class="skeleton-calendar-header">
          <div class="skeleton-nav-button"></div>
          <div class="skeleton-date-display"></div>
          <div class="skeleton-nav-button"></div>
        </div>
        
        <div class="skeleton-event-display">
          <div class="skeleton-event"></div>
          
          <!-- Time slots -->
          <div class="skeleton-timeslots">
            <div class="skeleton-timeslot">
              <div class="skeleton-time-label"></div>
              <div class="skeleton-time-content"></div>
            </div>
            <div class="skeleton-timeslot">
              <div class="skeleton-time-label"></div>
              <div class="skeleton-time-content"></div>
            </div>
            <div class="skeleton-timeslot">
              <div class="skeleton-time-label"></div>
              <div class="skeleton-time-content"></div>
            </div>
            <div class="skeleton-timeslot">
              <div class="skeleton-time-label"></div>
              <div class="skeleton-time-content"></div>
            </div>
            <div class="skeleton-timeslot">
              <div class="skeleton-time-label"></div>
              <div class="skeleton-time-content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .skeleton-activity-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      background-color: var(--skeleton-bg-primary);
      border-radius: 4px;
      box-shadow: var(--skeleton-shadow);
      overflow: hidden;
      height: 600px;
      width: 900px
    }

    .skeleton-header {
      padding: 16px;
      border-bottom: 1px solid var(--skeleton-border-color);
    }

    .skeleton-title {
      width: 200px;
      height: 24px;
      border-radius: 4px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
    }
    
    .skeleton-form {
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    
    .skeleton-input-large {
      width: 100%;
      height: 40px;
      border-radius: 4px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
    }

    .skeleton-input {
      width: 100%;
      height: 36px;
      border-radius: 4px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
    }

    .skeleton-action-buttons {
      display: flex;
      width: 100%;
      height: 40px;
      border: 1px solid var(--skeleton-border-color);
      border-radius: 4px;
      overflow: hidden;
    }

    .skeleton-button {
      flex: 1;
      height: 100%;
      border-right: 1px solid var(--skeleton-border-color);
    }

    .skeleton-button-primary {
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-button-primary-from) 25%, var(--skeleton-button-primary-mid) 50%, var(--skeleton-button-primary-to) 75%);
      background-size: 200% 100%;
    }
    
    .skeleton-datetime {
      display: flex;
      gap: 16px;
    }
    
    .skeleton-date-block, .skeleton-time-block {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    
    .skeleton-label {
      width: 60%;
      height: 16px;
      border-radius: 2px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
    }

    .skeleton-attendees, .skeleton-notes, .skeleton-lead, .skeleton-owner {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .skeleton-toolbar {
      display: flex;
      gap: 8px;
      padding: 8px;
      background-color: var(--skeleton-toolbar-bg);
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    .skeleton-tool {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-toolbar-tool-from) 25%, var(--skeleton-toolbar-tool-mid) 50%, var(--skeleton-toolbar-tool-to) 75%);
      background-size: 200% 100%;
    }

    .skeleton-textarea {
      width: 100%;
      height: 120px;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background-color: var(--skeleton-toolbar-bg);
    }

    .skeleton-dropdown {
      width: 100%;
      height: 36px;
      border-radius: 4px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
      position: relative;
    }

    .skeleton-dropdown::after {
      content: '';
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      width: 10px;
      height: 10px;
      background-color: var(--skeleton-dropdown-arrow);
      clip-path: polygon(50% 75%, 0% 25%, 100% 25%);
    }
    
    .skeleton-bottom-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 16px;
    }

    .skeleton-checkbox {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      border: 1px solid var(--skeleton-border-color);
    }

    .skeleton-calendar {
      padding: 16px;
      border-top: 1px solid var(--skeleton-border-color);
    }

    .skeleton-calendar-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .skeleton-nav-button {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
    }

    .skeleton-date-display {
      width: 200px;
      height: 24px;
      border-radius: 4px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
    }

    .skeleton-event-display {
      border: 1px solid var(--skeleton-border-color);
      border-radius: 4px;
      overflow: hidden;
    }

    .skeleton-event {
      margin: 8px;
      height: 32px;
      border-radius: 4px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-event-from) 25%, var(--skeleton-event-mid) 50%, var(--skeleton-event-to) 75%);
      background-size: 200% 100%;
    }

    .skeleton-timeslots {
      display: flex;
      flex-direction: column;
    }

    .skeleton-timeslot {
      display: flex;
      border-top: 1px solid var(--skeleton-border-color);
      height: 60px;
    }

    .skeleton-time-label {
      width: 60px;
      padding: 8px;
      display: flex;
      align-items: flex-start;
    }

    .skeleton-time-label::before {
      content: '';
      width: 40px;
      height: 16px;
      border-radius: 2px;
      animation: shimmer 1.8s infinite;
      background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
      background-size: 200% 100%;
    }

    .skeleton-time-content {
      flex: 1;
      border-left: 1px solid var(--skeleton-border-color);
    }
    
    /* Shimmer animation effect */
    @keyframes shimmer {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
    
    /* Staggered animation delays */
    .skeleton-input-large { animation-delay: 0.1s; }
    .skeleton-button-primary { animation-delay: 0.2s; }
    .skeleton-date-block .skeleton-input { animation-delay: 0.3s; }
    .skeleton-time-block .skeleton-input { animation-delay: 0.4s; }
    .skeleton-tool:nth-child(1) { animation-delay: 0.1s; }
    .skeleton-tool:nth-child(2) { animation-delay: 0.2s; }
    .skeleton-tool:nth-child(3) { animation-delay: 0.3s; }
  `]
})
export class ActivitySkeletonLoaderComponent {}